import ExcelController from '@/controller/ExcelController'
import moment from '@/util/MPMoment'

const borderStyle = {
    top: { style: 'thin', color: { argb: 'FF000000' } },
    left: { style: 'thin', color: { argb: 'FF000000' } },
    bottom: { style: 'thin', color: { argb: 'FF000000' } },
    right: { style: 'thin', color: { argb: 'FF000000' } }
}
const canceledBorderStyle = {
    top: { style: 'thick', color: { argb: 'FF494949' } },
    left: { style: 'thick', color: { argb: 'FF494949' } },
    bottom: { style: 'thick', color: { argb: 'FF494949' } },
    right: { style: 'thick', color: { argb: 'FF494949' } }
}

const bgColorWhite = 'FFFFFFFF'
const bgColorGray = 'FFD3D3D3'
const bgColorCanceled = 'FF9A9A9A'

// const parseTime = (timeString) => moment(timeString, 'HH:mm')
const formatTime = (date) => date.format('HH:mm')

function createTimeArray(timeArr, selectedInterval) {
    const startTime = moment().set('hour', timeArr[0].split(':')[0]).set('minute', timeArr[0].split(':')[1])
    const endTime = moment().set('hour', timeArr[timeArr.length - 1].split(':')[0]).set('minute', timeArr[timeArr.length - 1].split(':')[1])
    
    // const endTime = parseTime(timeArr[timeArr.length - 1])

    console.log('startTime : ', startTime.format("YYYY-MM-DD HH:mm"), 'endTime : ', endTime.format("YYYY-MM-DD HH:mm"))

    const totalMinutes = endTime.diff(startTime, 'minutes')
    const remainder = totalMinutes % selectedInterval
    if (remainder !== 0) {
        endTime.add(selectedInterval - remainder, 'minutes')
    }

    const newTimeArr = []
    while (startTime.isSameOrBefore(endTime)) {
        newTimeArr.push(formatTime(startTime))
        startTime.add(selectedInterval, 'minutes')
    }

    return newTimeArr
}

function generateCellStyle({ color = bgColorWhite, verticalAlignment = 'middle', horizontalAlignment = 'center', font } = {}) {
    return {
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color }
        },
        font: {
            name: 'Malgun Gothic',
            family: 2,
            size: 8,
            ...font
        },
        alignment: {
            vertical: verticalAlignment,
            horizontal: horizontalAlignment,
            wrapText: true
        }
    }
}

function adjustStartTimeToSchedule(startTime, timeArray, currentDate) {
    const currentDateYYYYMMDDString = moment(currentDate).format('YYYY-MM-DD')
    const HHMMString = moment(startTime).format('HH:mm')
    const momentStartTime = moment(`${currentDateYYYYMMDDString}T${HHMMString}`)

    const firstTime = moment(`${currentDateYYYYMMDDString}T${timeArray[0]}`)
    const lastTime = moment(`${currentDateYYYYMMDDString}T${timeArray[timeArray.length - 1]}`)

    if (momentStartTime.isBefore(firstTime)) {
        return timeArray[0] // timeArray의 첫 시간을 반환
    }

    if (momentStartTime.isAfter(lastTime)) {
        return timeArray[0] // 시작 시간이 마지막 시간 이후인 경우, timeArray의 첫 시간을 반환
    }

    let closestTime = timeArray[0]
    for (let i = 0; i < timeArray.length; i++) {
        const slotTime = moment(`${currentDateYYYYMMDDString}T${timeArray[i]}`)
        if (momentStartTime.isSameOrAfter(slotTime)) {
            closestTime = timeArray[i]
        } else {
            break
        }
    }
    return closestTime
}

function adjustEndTimeToSchedule(endTime, timeArray, currentDate) {
    const currentDateYYYYMMDDString = moment(currentDate).format('YYYY-MM-DD')
    const HHMMString = moment(endTime).format('HH:mm')
    const momentEndTime = moment(`${currentDateYYYYMMDDString}T${HHMMString}`)

    const firstTime = moment(`${currentDateYYYYMMDDString}T${timeArray[0]}`)
    const lastTime = moment(`${currentDateYYYYMMDDString}T${timeArray[timeArray.length - 1]}`)

    if (momentEndTime.isAfter(lastTime)) {
        return timeArray[timeArray.length - 1] // timeArray의 끝 시간을 반환
    }

    if (momentEndTime.isBefore(firstTime)) {
        return timeArray[timeArray.length - 1] // 끝 시간이 첫 시간 이전인 경우, timeArray의 끝 시간을 반환
    }

    let closestTime = timeArray[timeArray.length - 1]
    for (let i = timeArray.length - 1; i >= 0; i--) {
        const slotTime = moment(`${currentDateYYYYMMDDString}T${timeArray[i]}`)
        if (momentEndTime.isSameOrBefore(slotTime)) {
            closestTime = timeArray[i]
        } else {
            break
        }
    }
    return closestTime
}

/*
 * 예약스케줄 엑셀 만들기 (MDP-2295 ⑥ 3단계).
 *
 * 앞선 두 컨트롤러와 달리 화면 상태를 들고 있지 않다. 하는 일은 시트 데이터를 받아
 * exceljs 워크시트로 옮기는 계산뿐이고, 인스턴스 필드(colIndexMap 등)는 저장 한 번이
 * 돌아가는 동안만 쓰는 계산용 메모다. 그래서 해체 대상이 아니라 그대로 둔다.
 *
 * 지운 것: 생성자에 넘기던 model, timeArray / groups 게터·세터, updateCells,
 * resetCells / cells — 화면(ExcelSavePopup)이 자기 reservations 를 여기에 넣었다가
 * 그대로 돌려받는 왕복이었다. 팝업이 닫혔다 열려도 이 전역 배열은 남아 있어서,
 * 다시 조회하기 전에 저장하면 지난번 예약이 나갈 수 있었다.
 */
class ScheduleExcelController extends ExcelController {
    constructor() {
        super()
        this.totalGroupsSpan = 0
        this.columnEndTimes = []
        this.colIndexMap = new Map()
        this.reservationColumnIndices = new Map()
    }


    updateTotalGroupsSpan(newValue) {
        this.totalGroupsSpan = newValue
    }

    updateColIndexMap(column) {
        this.colIndexMap.set(column._id, column.colIndex)
    }

    updateReservationColumnIndices(columnID, x) {
        this.reservationColumnIndices.set(columnID, x)
    }

    async calculateBlocksAndColorsIndices(blocksAndColors, timeArr, saveInfo) {
        // const currentDateYYYYMMDDString = moment(saveInfo.selectedDate).format('YYYY-MM-DD')

        // const firstTime = moment(`${currentDateYYYYMMDDString}T${timeArr[0]}`)
        // const lastTime = moment(`${currentDateYYYYMMDDString}T${timeArr[timeArr.length - 1]}`)
        const currentDate = moment(saveInfo.selectedDate)

        const firstTime = moment(currentDate).set('hour', timeArr[0].split(':')[0]).set('minute', timeArr[0].split(':')[1])
        const lastTime = moment(currentDate).set('hour', timeArr[timeArr.length - 1].split(':')[0]).set('minute', timeArr[timeArr.length - 1].split(':')[1])

        const adjustedBlockData = blocksAndColors.map((blockGroup) => {
            const validBlocksSet = new Set(
                blockGroup.blocksAndColors.filter((block) => {
                    const blockStartTime = moment(block.startedAt)
                    const blockEndTime = moment(block.endedAt)

                    return (
                        (blockStartTime.isSameOrAfter(firstTime) && blockStartTime.isBefore(lastTime)) ||
                        (blockEndTime.isAfter(firstTime) && blockEndTime.isSameOrBefore(lastTime)) ||
                        (blockStartTime.isBefore(firstTime) && blockEndTime.isAfter(lastTime))
                    )
                })
            )

            return {
                ...blockGroup,
                blocksAndColors: Array.from(validBlocksSet)
                    .map((block) => {
                        const adjustedStartTime = adjustStartTimeToSchedule(block.startedAt, timeArr, saveInfo.selectedDate)
                        let adjustedEndTime = adjustEndTimeToSchedule(block.endedAt, timeArr, saveInfo.selectedDate)

                        if (!adjustedStartTime || !adjustedEndTime) {
                            return null
                        }

                        const startRow = timeArr.findIndex((time) => time === adjustedStartTime) + 4
                        let endRow = timeArr.findIndex((time) => time === adjustedEndTime) + 3

                        if (endRow <= startRow) {
                            const timeInterval = moment(timeArr[1], 'HH:mm').diff(moment(timeArr[0], 'HH:mm'), 'minutes')
                            adjustedEndTime = moment(adjustedStartTime, 'HH:mm').add(timeInterval, 'minutes').format('HH:mm')
                            endRow = timeArr.findIndex((time) => time === adjustedEndTime) + 3
                        }

                        if (startRow > endRow) {
                            return null
                        }

                        return {
                            ...block,
                            adjustedStartTime,
                            adjustedEndTime,
                            startRow,
                            endRow
                        }
                    })
                    .filter((block) => block !== null)
            }
        })

        return adjustedBlockData
    }

    async calculateWorkCodesIndices(workCodes, timeArr, saveInfo) {
        return workCodes
            .map((workCode) => {
                if (workCode.isFirstIndex) {
                    return {
                        ...workCode,
                        startRow: 4,
                        endRow: timeArr.length + 3
                    }
                }
                const adjustedStartTime = adjustStartTimeToSchedule(workCode.startedAt, timeArr, saveInfo.selectedDate)
                const adjustedEndTime = adjustEndTimeToSchedule(workCode.endedAt, timeArr, saveInfo.selectedDate)

                const startRow = timeArr.findIndex((time) => time === adjustedStartTime) + 4
                const endRow = timeArr.findIndex((time) => time === adjustedEndTime) + 3

                if (startRow > endRow) {
                    return null
                }

                return {
                    ...workCode,
                    adjustedStartTime,
                    adjustedEndTime,
                    startRow,
                    endRow
                }
            })
            .filter((workCode) => workCode !== null)
    }

    async calculateFinalCellStyles(worksheet, adjustedCellData, adjustedBlockData, adjustedWorkCodesData) {
        const cellStyles = new Map()
        const styledCells = new Set() // 이미 스타일이 적용된 셀을 추적

        const addStyleToCell = (row, column, fill, border, overwrite = false) => {
            const cellKey = `${row}-${column}`
            const existingStyle = cellStyles.get(cellKey) || { border: {} }

            if (styledCells.has(cellKey) && !overwrite) {
                // 이미 스타일이 적용된 셀에 대해 덮어쓰지 않도록 함
                cellStyles.set(cellKey, {
                    ...existingStyle,
                    border: {
                        top: border?.top || existingStyle.border.top,
                        bottom: border?.bottom || existingStyle.border.bottom,
                        left: border?.left || existingStyle.border.left,
                        right: border?.right || existingStyle.border.right
                    }
                })
            } else {
                styledCells.add(cellKey)
                cellStyles.set(cellKey, {
                    fill: fill || existingStyle.fill,
                    border: {
                        top: border?.top || existingStyle.border.top,
                        bottom: border?.bottom || existingStyle.border.bottom,
                        left: border?.left || existingStyle.border.left,
                        right: border?.right || existingStyle.border.right
                    }
                })
            }
        }

        // Work codes data 처리 (가장 낮은 우선순위)
        adjustedWorkCodesData.forEach((workCode) => {
            const duplicatedLength = this.reservationColumnIndices.get(workCode.columnID) ?? 0

            for (let i = 0; i <= duplicatedLength; i++) {
                const newColumnIndex = this.colIndexMap.get(workCode.columnID) + i
                let ranges = []

                if (workCode.isFirstIndex !== undefined) {
                    ranges.push({ startRow: workCode.startRow, endRow: workCode.endRow - 1, columnIndex: newColumnIndex })
                } else {
                    ranges.push({ startRow: 4, endRow: workCode.startRow - 1, columnIndex: newColumnIndex })
                    ranges.push({ startRow: workCode.endRow + 1, endRow: worksheet.rowCount, columnIndex: newColumnIndex })
                }

                ranges.forEach((range) => {
                    for (let row = range.startRow; row <= range.endRow; row++) {
                        const existingStyle = cellStyles.get(`${row}-${range.columnIndex}`)
                        const border = {
                            top: row === range.startRow ? canceledBorderStyle.top : existingStyle?.border?.top,
                            bottom: row === range.endRow ? canceledBorderStyle.bottom : existingStyle?.border?.bottom,
                            left: canceledBorderStyle.left,
                            right: canceledBorderStyle.right
                        }
                        addStyleToCell(row, range.columnIndex, bgColorCanceled, border)
                    }
                })
            }
        })

        // Block data 처리 (중간 우선순위)
        adjustedBlockData.forEach((blockGroup) => {
            const duplicatedLength = this.reservationColumnIndices.get(blockGroup.columnID) ?? 0

            for (let i = 0; i <= duplicatedLength; i++) {
                const newColumnIndex = this.colIndexMap.get(blockGroup.columnID) + i

                blockGroup.blocksAndColors.forEach((block) => {
                    const { startRow, endRow, cellType } = block

                    if (cellType === 'block') {
                        for (let row = startRow; row <= endRow; row++) {
                            const existingStyle = cellStyles.get(`${row}-${newColumnIndex}`)
                            const border = {
                                top: row === startRow ? canceledBorderStyle.top : existingStyle?.border?.top,
                                bottom: row === endRow ? canceledBorderStyle.bottom : existingStyle?.border?.bottom,
                                left: canceledBorderStyle.left,
                                right: canceledBorderStyle.right
                            }
                            addStyleToCell(row, newColumnIndex, bgColorCanceled, border)
                        }
                    }
                })
            }
        })

        // Reservation data 처리 (가장 높은 우선순위)
        adjustedCellData.forEach((cellGroup) => {
            cellGroup.reservations.forEach((reservation) => {
                const newColumnIndex = reservation.columnIndex + this.colIndexMap.get(cellGroup.columnID)

                for (let row = reservation.startRow; row <= reservation.endRow; row++) {
                    const existingStyle = cellStyles.get(`${row}-${newColumnIndex}`)
                    const border = existingStyle
                        ? {
                              top: row === reservation.startRow ? borderStyle.top : existingStyle.border.top,
                              bottom: row === reservation.endRow ? borderStyle.bottom : existingStyle.border.bottom,
                              left: existingStyle.border.left,
                              right: existingStyle.border.right
                          }
                        : borderStyle
                    addStyleToCell(row, newColumnIndex, reservation.bgColor.replace('#', 'FF'), border, true) // overwrite true
                }
            })
        })

        worksheet.eachRow((row) => {
            row.height = row.height < 15 ? 15 : row.height
        })

        return cellStyles
    }

    async calculateColumnIndices(cellArr, timeArr, saveInfo) {
        const timeInterval = timeArr.length > 1 ? moment(timeArr[1], 'HH:mm').diff(moment(timeArr[0], 'HH:mm'), 'minutes') : 15
        const currentDate = moment(saveInfo.selectedDate)

        const firstTime = moment(currentDate).set('hour', timeArr[0].split(':')[0]).set('minute', timeArr[0].split(':')[1])
        const lastTime = moment(currentDate).set('hour', timeArr[timeArr.length - 1].split(':')[0]).set('minute', timeArr[timeArr.length - 1].split(':')[1])

        // const firstTime = moment(`${currentDateYYYYMMDDString}T${timeArr[0]}`)
        // const lastTime = moment(`${currentDateYYYYMMDDString}T${timeArr[timeArr.length - 1]}`)

        const adjustedCellData = cellArr.map((cellGroup) => {
            const columnIndexTracker = {}
            const validReservationsSet = new Set(
                cellGroup.reservations.filter((reservation) => {
                    const reservationStartTime = moment(reservation.startedAt)
                    const reservationEndTime = moment(reservation.endedAt)

                    return (
                        (reservationStartTime.isSameOrAfter(firstTime) && reservationStartTime.isBefore(lastTime)) ||
                        (reservationEndTime.isAfter(firstTime) && reservationEndTime.isSameOrBefore(lastTime)) ||
                        (reservationStartTime.isBefore(firstTime) && reservationEndTime.isAfter(lastTime))
                    )
                })
            )

            return {
                ...cellGroup,
                reservations: Array.from(validReservationsSet)
                    .map((reservation) => {
                        const adjustedStartTime = adjustStartTimeToSchedule(reservation.startedAt, timeArr, saveInfo.selectedDate)
                        let adjustedEndTime = adjustEndTimeToSchedule(reservation.endedAt, timeArr, saveInfo.selectedDate)
                        console.log(`### ${adjustedStartTime} ~ ${adjustedEndTime}`)

                        if (!adjustedStartTime || !adjustedEndTime) {
                            return null
                        }

                        const startRow = timeArr.findIndex((time) => time === adjustedStartTime) + 4
                        console.log(`### first startRow : ${startRow}`)
                        let endRow = timeArr.findIndex((time) => time === adjustedEndTime) + 3
                        console.log(`### first endRow : ${startRow}`)

                        if (endRow < startRow) {
                            adjustedEndTime = moment(adjustedStartTime, 'HH:mm').add(timeInterval, 'minutes').format('HH:mm')
                            endRow = timeArr.findIndex((time) => time === adjustedEndTime) + 3
                        }

                        console.log(`### row : ${startRow} ~ ${endRow}`)
                        if (startRow > endRow) {
                            return null
                        }

                        let x = 0
                        while (columnIndexTracker[x] !== undefined && columnIndexTracker[x] >= startRow) {
                            x++
                        }
                        columnIndexTracker[x] = endRow
                        this.updateReservationColumnIndices(cellGroup.columnID, x)

                        return {
                            ...reservation,
                            adjustedStartTime,
                            adjustedEndTime,
                            columnIndex: x,
                            startRow,
                            endRow
                        }
                    })
                    .filter((reservation) => reservation !== null)
            }
        })

        return adjustedCellData
    }

    async saveScheduleExcel(data, saveInfo, selectedInfo) {
        const worksheet = this.setupWorkSheet('예약스케줄')

        const { selectedGroups, selectedManagers, selectedTimeInterval } = selectedInfo
        const { groupArr, timeArr, cellArr, workCodesArr, blocksAndColorsArr } = data

        const selectedGroupsSet = new Set(selectedGroups)
        const selectedManagersSet = new Set(selectedManagers)

        const selectedDateYYMMDD = moment(saveInfo.selectedDate).format('YYMMDD').toString()
        const defaultFileName = `${saveInfo.hospitalName}_예약스케줄_${selectedDateYYMMDD}.xlsx`

        const filteredGroupArr = groupArr.reduce((acc, group) => {
            if (selectedGroupsSet.has(group._id)) {
                const filteredColumns = group.columns.filter((column) => selectedManagersSet.has(column._id))
                if (filteredColumns.length > 0) {
                    acc.push({
                        ...group,
                        columns: filteredColumns
                    })
                }
            }
            return acc
        }, [])
        const filteredCellArr = cellArr.filter((cell) => selectedManagers.includes(cell.columnID))
        const filteredTimeArr = createTimeArray(timeArr, selectedTimeInterval)
        const filteredBlocksAndColors = blocksAndColorsArr.filter((blockGroup) => selectedManagers.includes(blockGroup.columnID))
        const filteredWorkCodesArr = workCodesArr.filter((workCode) => selectedManagers.includes(workCode.columnID))

        const adjustedCellData = await this.calculateColumnIndices(filteredCellArr, filteredTimeArr, saveInfo)
        const adjustedBlockData = await this.calculateBlocksAndColorsIndices(filteredBlocksAndColors, filteredTimeArr, saveInfo)
        const adjustedWorkCodesData = await this.calculateWorkCodesIndices(filteredWorkCodesArr, filteredTimeArr, saveInfo)

        this._populateTimeColumn(worksheet, filteredTimeArr)

        await this._populateDataColumns(worksheet, filteredGroupArr, adjustedCellData)
        await this._populateReservationData(worksheet, adjustedCellData)

        const cellStyles = await this.calculateFinalCellStyles.call(this, worksheet, adjustedCellData, adjustedBlockData, adjustedWorkCodesData)
        this._applyFinalCellStyles(worksheet, cellStyles)
        this._applyBordersToSpecificCells(worksheet)

        this._configureWorksheetTitle(worksheet, saveInfo)

        return await this.saveFile('예약스케줄', defaultFileName, worksheet)
    }

    async _populateReservationData(worksheet, adjustedCellData) {
        for (const cellGroup of adjustedCellData) {
            for (const reservation of cellGroup.reservations) {
                const { startRow, endRow } = reservation

                const { note, userName, birth, programTitle, bgColor, usingChartNumber, chartNumber } = reservation

                const chartNumText = chartNumber?.length ? ` (${chartNumber ?? ''})` : ' ()'
                const birthText = birth?.length ? ` (${birth?.substring(2)})` : ' ()'
                const noteText = note ? `\n${note}` : ''

                const birthOrChartNumText = usingChartNumber ? chartNumText : birthText
                const programTextWithNoteText = `${programTitle}${noteText}`

                const lineCount = `${userName}${birthOrChartNumText}\n${programTextWithNoteText}`?.split('\n').length + 1
                const estimatedHeight = lineCount * 15

                const newColumnIndex = reservation.columnIndex + this.colIndexMap.get(cellGroup.columnID)

                if (this.canMergeCells(worksheet, startRow, newColumnIndex, endRow, newColumnIndex)) {
                    this.mergeCells(worksheet, startRow, newColumnIndex, endRow, newColumnIndex)
                }

                const richTextValue = {
                    richText: [
                        { text: `${userName}`, font: { bold: true, size: 8, name: 'Malgun Gothic' } },
                        { text: `${birthOrChartNumText}\n`, font: { bold: true, size: 8, name: 'Malgun Gothic' } },
                        { text: programTextWithNoteText, font: { size: 8, name: 'Malgun Gothic' } }
                    ]
                }

                this.setCellValue(
                    worksheet,
                    startRow,
                    newColumnIndex,
                    richTextValue,
                    generateCellStyle({
                        color: bgColor.replace('#', 'FF')
                    })
                )

                // 셀의 넓이 및 높이 조정
                const mergedRowCount = endRow - startRow + 1
                const adjustedHeight = estimatedHeight / mergedRowCount
                worksheet.getRow(startRow).height = adjustedHeight ?? 15
                worksheet.getColumn(newColumnIndex).width = 16
            }
        }
    }

    async _populateDataColumns(worksheet, groupArr, cellArr) {
        let currentColIndex = 1 // 이전 컬럼의 마지막 위치를 저장하는 변수
        groupArr?.forEach((group, index) => {
            if (group.columns?.length > 0) {
                const groupStartCol = currentColIndex + 1 // 그룹의 시작점은 현재 인덱스 + 1
                for (const column of group.columns) {
                    const cellGroup = cellArr.find((cellGroup) => cellGroup.columnID === column._id)
                    const colIndex = currentColIndex + 1 // 현재 컬럼 인덱스 계산

                    this.updateColIndexMap({
                        colIndex,
                        _id: column._id
                    })
                    this.setCellValue(
                        worksheet,
                        3,
                        colIndex,
                        column.title,
                        generateCellStyle({
                            color: bgColorGray,
                            font: { bold: true }
                        })
                    )

                    const maxX = cellGroup?.reservations?.length > 0 ? Math.max(...cellGroup.reservations.map((reservation) => reservation.columnIndex)) : 0

                    // 병합 가능 여부 추가 확인
                    if (maxX > 0 && this.canMergeCells(worksheet, 3, colIndex, 3, colIndex + maxX)) {
                        this.mergeCells(worksheet, 3, colIndex, 3, colIndex + maxX)
                    }
                    currentColIndex = colIndex + maxX // 다음 컬럼 위치를 위해 업데이트
                }

                const groupEndCol = currentColIndex // 그룹의 끝점은 마지막 컬럼의 끝 위치

                if (groupStartCol <= groupEndCol) {
                    if (groupArr.length === index + 1) {
                        this.updateTotalGroupsSpan(groupEndCol)
                    }

                    this.mergeCells(worksheet, 2, groupStartCol, 2, groupEndCol)
                    this.setCellValue(
                        worksheet,
                        2,
                        groupStartCol,
                        group.title,
                        generateCellStyle({
                            color: bgColorGray,
                            font: { bold: true }
                        })
                    )
                }
            }
        })

        worksheet.getRow(3).height = 17
    }

    _populateTimeColumn(worksheet, timeArr) {
        this.mergeCells(worksheet, 2, 1, 3, 1)
        this.setCellValue(
            worksheet,
            2,
            1,
            '시간',
            generateCellStyle({
                color: bgColorGray,
                font: { bold: true }
            })
        )

        const displayTimeArr = timeArr.slice(0, -1)
        displayTimeArr.forEach((time, index) => {
            this.setCellValue(worksheet, index + 4, 1, time, generateCellStyle())
        })
    }

    _configureWorksheetTitle(worksheet, saveInfo) {
        const { hospitalName, selectedDate } = saveInfo

        const selectedDateMMDD = moment(selectedDate).format('MM/DD').toString()

        if (this.canMergeCells(worksheet, 1, 1, 1, this.totalGroupsSpan)) {
            this.mergeCells(worksheet, 1, 1, 1, this.totalGroupsSpan)
        }
        this.setCellValue(
            worksheet,
            1,
            1,
            `${hospitalName} 예약스케줄 ${selectedDateMMDD}`,
            generateCellStyle({
                font: {
                    bold: true,
                    size: 11
                }
            })
        )
        worksheet.getRow(1).height = 22
    }

    _applyFinalCellStyles(worksheet, cellStyles) {
        cellStyles.forEach((style, cellKey) => {
            const [row, column] = cellKey.split('-').map(Number)
            const cell = worksheet.getCell(row, column)
            cell.style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: style.fill }
            }
            cell.border = style.border
        })
    }

    _applyBordersToSpecificCells(worksheet) {
        // 첫 번째 시간 Column에 테두리 적용
        for (let row = 4; row <= worksheet.rowCount; row++) {
            const cell = worksheet.getCell(row, 1)
            const nextCell = worksheet.getCell(row, 2)

            cell.border = {
                top: borderStyle.top,
                left: borderStyle.left,
                bottom: borderStyle.bottom,
                right: nextCell?.border?.left ? undefined : borderStyle.right
            }
        }

        // 그룹 및 하위 컬럼에 테두리 적용
        for (let row = 1; row <= 3; row++) {
            for (let col = 1; col <= worksheet.columnCount; col++) {
                const cell = worksheet.getCell(row, col)

                cell.border = {
                    ...cell.border,
                    ...borderStyle
                }
            }
        }

        // 가장 큰 테두리 추가
        const firstRow = 1
        const lastRow = worksheet.rowCount
        const firstCol = 1
        const lastCol = worksheet.columnCount

        for (let col = firstCol; col <= lastCol; col++) {
            const topCell = worksheet.getCell(firstRow, col)
            const bottomCell = worksheet.getCell(lastRow, col)

            topCell.border = { ...topCell.border, top: borderStyle.top }
            bottomCell.border = { ...bottomCell.border, bottom: bottomCell?.style?.border?.bottom?.style === 'thick' ? canceledBorderStyle.bottom : borderStyle.bottom }
        }

        for (let row = firstRow; row <= lastRow; row++) {
            const leftCell = worksheet.getCell(row, firstCol)
            const rightCell = worksheet.getCell(row, lastCol)
            leftCell.border = { ...leftCell.border, left: borderStyle.left }
            rightCell.border = { ...rightCell.border, right: borderStyle.right }
        }
    }
}

const scheduleExcelController = new ScheduleExcelController()

export default scheduleExcelController
